import coreService from '@/services/core'
import promotionService from '@/services/promotion'
import userService from '@/services/user'
import moment from 'moment-timezone'
import router from '@/router'
import _ from 'lodash'
import Vue from 'vue'
import CipherService from "@/services/cipher"

/* eslint-disable */
function ck_intersection(num1s, num1e, num2s, num2e) {
    var a1 = _.range(num1s, parseInt(num1e) + 1);
    var a2 = _.range(num2s, parseInt(num2e) + 1);
    var aa = _.intersection(a1, a2);
    return (aa.length > 0 ? true : false)
}
export default {
    loadData: false,
    checkBackdrop: false,
    namespaced: true,
    state: {
        step: 'step-1',
        filed_product: ['code', 'title_th', 'seu_code', 'productcg_code', 'cost', 'price'],
        groups: [],
        subgroups: [],
        cggroups: [],
        default_set: {
            name: '',
            default_price: '',
            mix_set: false,
            conditions: [],
            promotions: [],
            customers: [],
            status: false
        },
        probrowse: [],
        value: {
            type: 'draft',
            comment: '',
            // promotion_type: 'IS',
            promotion_type: '',
            promotion_code: null,
            promotion_title: null,
            promotion_detail: null,
            startdate: null,
            enddate: null,
            target_type: 'none',
            target: 0,
            set_value: null,
            sales_value: null,
            promotion_active: false,
            products: [],
            wf: [],
            sets: [{
                name: 'SET 1',
                default_price: '',
                mix_set: false,
                conditions: [],
                promotions: [],
                customers: [],
                status: false
            }, ],
            repeat: false,
            sum_promotion: 0,
            sum_start_up: 0,
            promotion_repeat: [],
            net_price_flag: false,
            is_fasttrack: false
        },
        unitmaster: [],
        customer_groups: [],
        product_groups: [],
        origin_customer_groups: [],
        default_price: [],
        alertshow: false,
        alertcontent: null,
        rowsNetprice: [],
        statusAction: 'create',
        ck_promotion: false,
        alertCondition: '',
        checked_promotion: [],
        checked_promotion_selected: [],
        tmp_product_selected: [],
        tmp_checked_promotion_selected: [],
        tmp_checked_promotion: []
    },
    mutations: {
        setNetPriceFlag(state, value) {
            state.value.net_price_flag = value
        },
        setTmpProductSelected(state, value) {
            state.tmp_product_selected = value
        },
        setTmpCheckedPromotionSelected(state, value) {
            state.tmp_checked_promotion_selected = value
        },
        setTmpCheckedPromotion(state, value) {
            state.tmp_checked_promotion = value
        },
        setCheckedPromotion(state, value) {
            state.checked_promotion = value
        },
        setCheckedPromotionSelected(state, value) {
            state.checked_promotion_selected = value
        },
        setPromotionRepeat(state, value) {
            state.value.repeat = value
        },
        setSumPromotion(state, value) {
            state.value.sum_promotion = value
        },
        setSumStartUp(state, value) {
            state.value.sum_start_up = value
        },
        loadingPage(state, value) {
            state.loadData = value
            state.checkBackdrop = value
        },
        setStep(state, step) {
            state.step = step
        },
        setType(state, value) {
            state.value.type = value
        },
        setComment(state, value) {
            state.value.comment = value
        },
        setStatusAction(state, value) {
            state.statusAction = value
        },
        setalertCondition(state, value) {
            state.alertCondition = value
        },
        setckPromotion(state, value) {
            state.ck_promotion = value
        },
        setPromotionType(state, value) {
            state.value.promotion_type = value
        },
        update(state, data) {
            const field = data.field
            state.value[field] = data.value
        },
        setGroups(state, value) {
            state.groups = value
        },
        setSubgroups(state, value) {
            state.subgroups = value
        },
        setCGgroups(state, value) {
            state.cggroups = value
        },
        setUnitMaster(state, value) {
            state.unitmaster = value
        },
        setProductBrowse(state, value) {
            state.probrowse = value
        },
        setProductsMaster(state, value) {
            state.value.products = value
        },
        setValueSets(state, value) {
            state.value.sets = value
        },
        setValueConditions(state, value) {
            state.value.sets[value.index].conditions = value.conditions
        },
        setValuePromotions(state, value) {
            state.value.sets[value.index].promotions = value.promotions
        },
        setValueCustomers(state, value) {
            //state.value.sets[value.index].customers = value.customers
            if (value.customers === undefined) {
                value.customers = value.customer;
            }
            state.value.sets[value.index].customers = value.customers
                //        state.value.sets[value.index].customers = JSON.parse(JSON.stringify(value.customers))
        },
        setValuePromotionProducts(state, value) {
            state.value.sets[value.x].promotions[value.i].products = value.result
        },
        setSetStatus(state, value) {
            state.value.sets[value.index].status = value.status
        },
        setFormatDate(state, value) {
            state.value[value.field] = value.value
        },
        clearPromotionCreate(state) {
            state.value = {
                type: 'draft',
                comment: '',
                // promotion_type: 'IS',
                promotion_type: '',
                promotion_code: null,
                promotion_title: null,
                promotion_detail: null,
                startdate: null,
                enddate: null,
                target_type: 'none',
                target: 0,
                set_value: null,
                sales_value: null,
                promotion_active: false,
                products: [],
                wf: [],
                sets: [{
                    name: '',
                    default_price: '',
                    mix_set: false,
                    conditions: [],
                    promotions: [],
                    customers: [],
                    status: false
                }, ],
                repeat: false,
                sum_promotion: 0,
                sum_start_up: 0,
                promotion_repeat: [],
                net_price_flag: false,
                is_fasttrack: false
            }
            state.target_type = 'none',
                state.statusAction = 'create'
        },
        setCustomerGroups(state, value) {
            state.customer_groups = value
        },
        setOriginCustomerGroups(state, value) {
            state.origin_customer_groups = value
        },
        setProductGroups(state, value) {
            state.product_groups = value
        },
        setDefaultPrice(state, value) {
            state.default_price = value
        },
        setPromotion(state, promotion) {
            _.forEach(promotion.sets, (set, x) => {
                _.forEach(set.promotions, (pm, i) => {
                    if (pm.type == 'Discount') {
                        promotion.sets[x].promotions[i]['vclass'] = 'mktops-step3-flex'
                    } else if (pm.type == 'Net Price') {
                        promotion.sets[x].promotions[i]['vclass'] = 'mktops-display-flex'
                    } else if (pm.type == 'Free item') {
                        promotion.sets[x].promotions[i]['vclass'] = ''
                        _.forEach(pm.value, (item, k) => {
                            if (item.qty != '') {
                                promotion.sets[x].promotions[i].value[k].ck_qty = '#fff'
                                promotion.sets[x].promotions[i].value[k].ck_ratio = '#efefef'
                            } else if (item.ratio[0] != '' || item.ratio[1] != '') {
                                promotion.sets[x].promotions[i].value[k].ck_qty = '#efefef'
                                promotion.sets[x].promotions[i].value[k].ck_ratio = '#fff'
                            }
                            promotion.sets[x].promotions[i].value[k].status = item.status;
                        })
                    }
                })
            })

            if (promotion.target_type == 'Set') {
                promotion.set_value = promotion.target
            } else if (promotion.target_type == 'Sales Valus') {
                promotion.sales_value = promotion.target
            }
            state.value = _.cloneDeep(promotion)
        },
        setAlertShow(state, value) {
            state.alertshow = value.value
        },
        setProductNetprice(state, value) {
            state.rowsNetprice = value
        },
    },
    actions: {
        getProductsMaster({ commit, dispatch, state }, productsData) {
            if (productsData.productCode) {
                coreService.getProductsMaster(productsData.productCode)
                    .then((response) => {
                        const products = state.value.products
                        const netprice = state.rowsNetprice
                        var mapped = _.map(response, _.partialRight(_.pick, state.filed_product))
                        var group = (products.length > 0) ? _.differenceBy(mapped, products, 'code') : mapped
                        if (group.length > 0) {
                            _.forEach(group, (value) => {
                                value.netprice = netprice[value.code]
                                products.push(value)
                            })
                        } else {
                            _.forEach(products, (value) => {
                                value.netprice = netprice[value.code]
                            })
                        }
                        commit('setProductsMaster', products)
                        setTimeout(() => {
                            dispatch('updateNetPrice')
                        }, 500)
                    })
                    .catch((error) => console.log(error))
            } else {
                commit('setProductsMaster', [])
            }
        },
        getProductBrowse({ commit, state }, productsData) {
            coreService.getProductBrowse(productsData)
                .then((response) => {
                    const probrowse = state.probrowse
                    state.probrowse = []
                    var mapped = (productsData['loading'] == 1) ? _.unionWith(probrowse, response, _.isEqual) : response
                    commit('setProductBrowse', mapped)
                })
                .catch((error) => console.log(error))
        },
        getUnitMaster({ commit }) {
            coreService.getUnitMaster()
                .then((response) => {
                    const data = []
                    for (const x in response) {
                        data[response[x].code] = response[x].title
                    }
                    commit('setUnitMaster', data)
                })
                .catch((error) => console.log(error))
        },
        getGroups({ commit }) {
            coreService.getGroups()
                .then((response) => {
                    commit('setGroups', response)
                })
                .catch((error) => console.log(error))
        },
        getSubgroups({ commit }, groupsMode) {
            if (groupsMode.parentCode) {
                coreService.getSubgroups(groupsMode.parentCode)
                    .then((response) => {
                        commit('setSubgroups', response)
                    })
                    .catch((error) => console.log(error))
            } else {
                commit('setSubgroups', [])
            }
        },
        getCGgroups({ commit }, subgroupsMode) {
            if (subgroupsMode.parentCode) {
                coreService.getSubgroups(subgroupsMode.parentCode)
                    .then((response) => {
                        commit('setCGgroups', response)
                    })
                    .catch((error) => console.log(error))
            } else {
                commit('setCGgroups', [])
            }
        },
        insertSet({ commit, state }, index) {
            const sets = state.value.sets
            if (!sets[index]) {
                var tempSet;
                if (sets[0].conditions.length > 0) {
                    tempSet = _.cloneDeep(state.default_set)
                    tempSet.conditions = _.cloneDeep(sets[0].conditions)
                    tempSet.conditions[0].max = false
                    tempSet.conditions[0].min = false
                    tempSet.conditions[0].max_value = false
                    tempSet.conditions[0].min_value = false
                    tempSet.name = 'SET ' + (sets.length + 1)
                    sets.push(_.cloneDeep(tempSet))
                } else {
                    tempSet = _.cloneDeep(state.default_set)
                    tempSet.name = 'SET ' + (sets.length + 1)
                    sets.push(_.cloneDeep(tempSet))
                }
            } else {
                sets.push(_.cloneDeep(sets[index]))
            }
            let key_max_value = state.value.sets.length - 2;
            let key = state.value.sets.length - 1;
            if (sets[key_max_value].conditions[0] !== undefined) {
                sets[key].conditions[0].min = (sets[key_max_value].conditions[0].max == "" || sets[key_max_value].conditions[0].max == null) ? "" : parseFloat(sets[key_max_value].conditions[0].max) + 1;
                sets[key].conditions[0].max = false;
                sets[key].conditions[0].min_value = (sets[key_max_value].conditions[0].max_value == "" || sets[key_max_value].conditions[0].max_value == null) ? "" : parseFloat(sets[key_max_value].conditions[0].max_value) + 1;
                sets[key].conditions[0].max_value = false;
            }
            sets[key].name = "SET " + state.value.sets.length;
            commit('setValueSets', sets)
        },
        resetSet({ commit, state }, index) {
            const sets = state.value.sets
            if (sets[index]) {
                sets[index].name = ''
                sets[index].default_price = ''
                sets[index].mix_set = false
                sets[index].conditions = []
                sets[index].promotions = []
                sets[index].customers = []
                sets[index].status = false
                commit('setValueSets', sets)
            }
        },
        deleteSet({ commit, state }, index) {
            const sets = state.value.sets
            if (sets[index]) {
                sets.splice(index, 1)
                commit('setValueSets', sets)
            }
        },
        insertCondition({ commit, state }, { index, type }) {
            const conditions = state.value.sets[index].conditions
            conditions.push({
                type,
                min: null,
                max: null,
                max_level: false,
                max_value_level: false,
                maxdis: false,
                maxdis_value: false
            })
            commit('setValueConditions', { index, conditions })
        },
        updateCondition({ commit, state }, { index, type }) {
            const conditions = state.value.sets[index].conditions
            if (type === 'max_level') {
                conditions[0].max = null
                conditions[0].maxdis = false
                if (conditions[0].max_level) {
                    conditions[0].max = '9999999'
                    conditions[0].maxdis = true
                }
            } else if (type === 'max_value_level') {
                conditions[0].max_value = null
                conditions[0].maxdis_value = false
                if (conditions[0].max_value_level) {
                    conditions[0].max_value = '9999999'
                    conditions[0].maxdis_value = true
                }
            } else {
                if (conditions[0].min * 1 >= conditions[0].max * 1) {
                    // conditions[0].max = (conditions[0].min !== null)?conditions[0].min*1+1:conditions[0].min
                }
            }
            if (conditions[0].min !== undefined) {
                conditions[0].min = (conditions[0].min === null || conditions[0].min === "") ? conditions[0].min : parseFloat(conditions[0].min)
            }
            if (conditions[0].max !== undefined) {
                conditions[0].max = (conditions[0].max === null || conditions[0].max === "") ? conditions[0].max : parseFloat(conditions[0].max)
            }
            if (conditions[0].count !== undefined) {
                conditions[0].count = (conditions[0].count === null || conditions[0].count === "") ? conditions[0].count : parseFloat(conditions[0].count)
            }

            //-- START COUNT MIX --//
            if (conditions[0].min_value !== undefined) {
                conditions[0].min_value = (conditions[0].min_value === null || conditions[0].min_value === "") ? conditions[0].min_value : parseFloat(conditions[0].min_value)
            }
            if (conditions[0].max_value !== undefined) {
                conditions[0].max_value = (conditions[0].max_value === null || conditions[0].max_value === "") ? conditions[0].max_value : parseFloat(conditions[0].max_value)
            }
            //-- END COUNT MIX --//

            commit('setValueConditions', { index, conditions })
        },
        deleteCondition({ commit, state }, { index, index_condition }) {
            const conditions = state.value.sets[index].conditions
            if (conditions[index_condition]) {
                conditions.splice(index_condition, 1)
                commit('setValueConditions', { index, conditions })
            }
        },
        insertPromotion({ commit, state }, { index, type }) {
            const promotions = state.value.sets[index].promotions
            let vclass = null
            let _value = null
                //let products = null
            if (type === 'Discount')
                vclass = 'mktops-step3-flex'
            else if (type === 'Net Price') {
                vclass = 'mktops-display-flex'
                    // = _.map(state.value.products, _.partialRight(_.pick, state.filed_product))
            } else if (type === 'Free item') {
                // let aa = {ck_qty:'#fff',ck_ratio:'#fff',display:'show',code:'103118',desc:'FBNอาร์ติโก้ 56x76ซม',unit:'PK',qty:'',ratio:['','']};
                // let aa2 = {ck_qty:'#fff',ck_ratio:'#fff',display:'show',code:'103117',desc:'FBNอาร์ติโก้ 56x76ซม',unit:'PK',qty:'',ratio:['','']};
                // _value = [aa,aa2];
                _value = [];
            }
            promotions.push({
                type,
                vclass,
                //products,
                value: _value
            })
            commit('setValuePromotions', { index, promotions })
        },
        updatePromotion({ commit, state }, { index, type }) {
            const promotions = state.value.sets[index].promotions
            _.forEach(promotions, (set, x) => {
                if (set.type === 'Discount' && (set.value * 1 < 0 || set.value * 1 > 100)) {
                    promotions[x].value = (set.value * 1 > 100) ? 100 : null
                } else if (set.type === 'Net Price' && set.value * 1 < 0) {
                    promotions[x].value = null
                } else if (set.type !== 'Free item') {
                    promotions[x].value = parseFloat(promotions[x].value)
                }
            })
            commit('setValuePromotions', { index, promotions })
        },
        updatePromotion_freeItem({ commit, state }, { index, temp_freeitem }) {
            const promotions = state.value.sets[index].promotions
            _.forEach(promotions, (set, x) => {
                if (set.type === 'Free item') {
                    for (let i = 0; i < temp_freeitem.length; i++) {
                        if (temp_freeitem[i].qty !== undefined && temp_freeitem[i].qty) {
                            temp_freeitem[i].qty = parseFloat(temp_freeitem[i].qty);
                        }
                        if (temp_freeitem[i].ratio !== undefined && temp_freeitem[i].ratio[0]) {
                            temp_freeitem[i].ratio[0] = parseFloat(temp_freeitem[i].ratio[0]);
                        }
                        if (temp_freeitem[i].ratio !== undefined && temp_freeitem[i].ratio[1]) {
                            temp_freeitem[i].ratio[1] = parseFloat(temp_freeitem[i].ratio[1]);
                        }
                    }
                    promotions[x].value = temp_freeitem
                }
            })
            commit('setValuePromotions', { index, promotions })
        },
        deletePromotion({ commit, state }, { index, index_promotion }) {
            const promotions = state.value.sets[index].promotions
            if (promotions[index_promotion]) {
                promotions.splice(index_promotion, 1)
                commit('setValuePromotions', { index, promotions })
            }
        },
        insertCustomer({ commit, state }, { index, customer }) {
            const customers = state.value.sets[index].customers
            let customer_groups = state.customer_groups
            let check = false
            for (const x in customers) {
                if (customers[x]._id == customer._id) {
                    check = true
                    break
                }
                customer_groups = _.remove(customer_groups, function(n) {
                    return n._id != customers[x]._id;
                })
            }
            if (!check) {
                //          customers.push(customer)
                //          commit('setValueCustomers',{index,customers})
                commit('setCustomerGroups', customer_groups)
            }
            commit('setValueCustomers', { index, customer })
        },
        deleteCustomer({ commit, state }, { index, index_customer }) {
            const customers = state.value.sets[index].customers
            let customer_groups = state.customer_groups
            const customers_push = customers[index_customer]
            let check = false
            if (customers[index_customer]) {
                for (const x in customer_groups) {
                    if (customer_groups[x]._id == customers[index_customer]._id) {
                        check = true
                        break
                    }
                }
                customers.splice(index_customer, 1)
                if (!check) {
                    customer_groups.push(customers_push)
                    commit('setCustomerGroups', _.sortBy(customer_groups, [function(o) { return o.group_name; }]))
                }
                commit('setValueCustomers', { index, customers })
            }
        },
        updateNetPrice({ commit, state }) {
            const products = state.value.products
            _.forEach(state.value.sets, (set, x) => {
                _.forEach(set.promotions, (pm, i) => {
                    if (pm.type === 'Net Price' && pm.products != null) {
                        const result = _.unionBy(pm.products, products, "code")
                        commit('setValuePromotionProducts', { x, i, result })
                    }
                })
            })
        },
        setFormatDate({ commit, state }) {
            const startdate = moment(new Date(state.value.startdate))
            const enddate = moment(new Date(state.value.enddate))
            commit('setFormatDate', { field: 'startdate', value: startdate.format('YYYY-MM-DD') })
            commit('setFormatDate', { field: 'enddate', value: enddate.format('YYYY-MM-DD') })
        },
        async createPromotionToServer({ commit, state }) {
            var promotion = state.value
            _.forEach(promotion.sets, (set, x) => {
                _.forEach(set.promotions, (pm, i) => {

                    if (promotion.sets[x].conditions[0].min == "" || promotion.sets[x].conditions[0].min == null) {
                        promotion.sets[x].conditions[0].min = "";
                    }
                    if (promotion.sets[x].conditions[0].max == "" || promotion.sets[x].conditions[0].max == null) {
                        promotion.sets[x].conditions[0].max = "";
                    }

                    delete promotion.sets[x].promotions[i]['vclass']
                    if (pm.type === 'Free item') {
                        _.forEach(pm.value, (item, k) => {
                            delete promotion.sets[x].promotions[i].value[k].ck_qty
                            delete promotion.sets[x].promotions[i].value[k].ck_ratio
                        })

                        promotion.sets[x].promotions[i].freeitem_flag = true;
                    }
                })
            })

            _.forEach(promotion.promotion_repeat, (repeat, i) => {
                delete promotion.promotion_repeat[i].promotion_title;
            });

            if (state.value.target_type == 'Set') {
                promotion.target = state.value.set_value
            } else if (state.value.target_type == 'Sales Valus') {
                promotion.target = state.value.sales_value
            }

            let user = Vue.$jwt.decode(localStorage.getItem('token'))
            var user_db
            await userService.getInfo(user.id)
                .then((response) => {
                    user_db = response
                })
            if (state.value.type == 'Pending') {
                // await CipherService.getBossCode(user.code).then(response => {
                //     if (response.resource.length > 0) {
                //         let boss_code = response.resource[0].boss_code;
                //         promotion.approve_by = boss_code
                //     }
                // }).catch(error => console.log(error));
                if (promotion.approve_by === undefined || promotion.approve_by === '') {
                    return false;
                }
                //promotion.approve_by = user_db.boss_code
            }

            if (state.value.type == 'Active') {
                state.value.type_active = false;
            }

            promotion.u_name = user_db.displayname
            promotion.firstname = user_db.firstname
                // state.value.promotion_active = false;

            if (state.statusAction == 'create') {
                promotion.c_time = moment(new Date()).format('YYYY-MM-DD HH:mm')
                promotion.u_time = moment(new Date()).format('YYYY-MM-DD HH:mm')
                if (user_db.code) {
                    promotion.c_user = user_db.code
                    promotion.u_user = user_db.code
                }

                let promotionId = '';
                promotionService.maxPromotionID()
                    .then(function(response) {
                        promotionId = (response.length == 0) ? 1 : parseInt(response[0].promotion_id) + 1;
                        promotion.promotion_id = promotionId;

                        promotionService.createPromotion(promotion)
                            .then(() => {
                                commit('clearPromotionCreate')
                                commit('loadingPage', false)
                                router.replace('/promotion/manage')
                            })
                            .catch((error) => console.log(error))
                    })
                    .catch((error) => console.log(error))
            } else if (state.statusAction == 'edit') {
                promotion.u_time = moment(new Date()).format('YYYY-MM-DD HH:mm')
                if (user_db.code) {
                    promotion.u_user = user_db.code
                }
                await promotionService.updatePromotion(promotion)
                    .then((rs) => {
                        commit('clearPromotionCreate')
                        commit('loadingPage', false)
                        router.replace('/promotion/manage')
                        return rs;
                    })
                    .catch((error) => console.log(error))

            }

        },
        getCustomerGroups({ commit, state }) {
            if (state.customer_groups.length == 0)
                promotionService.getCustomerGroups()
                .then((response) => {
                    let bk_response = JSON.parse(JSON.stringify(response));
                    commit('setCustomerGroups', _.remove(response, function(n) {
                        return n.group_name != '';
                    }))

                    commit('setOriginCustomerGroups', _.remove(bk_response, function(n) {
                        return n.group_name != '';
                    }))
                })
                .catch((error) => console.log(error))
        },
        getProductGroups({ commit, state }) {
            if (state.product_groups.length == 0)
                promotionService.getProductGroups()
                .then((response) => {
                    // commit('setProductGroups', _.remove(response, function(n) {
                    //     return n.group_name != '';
                    // }))
                })
                .catch((error) => console.log(error))
        },
        getDefaultPrice({ commit, state }) {
            if (state.default_price.length == 0)
            /* START Change 09.05.2019 */
            // coreService.getDefaultPrice()
                promotionService.getDefaultPrice()
                /* END Change 09.05.2019 */
                .then((response) => {
                    commit('setDefaultPrice', response)
                })
                .catch((error) => console.log(error))
        },
        checkCodeFreeItem({ commit, state }, { code, setIndex, index }) {
            coreService.getProductsMaster(code.split(','))
                .then((response) => {
                    if (response.length > 0) {
                        var mapped = _.map(response, _.partialRight(_.pick, state.filed_product))
                        const result = _.unionBy(state.value.sets[setIndex].promotions[index].products, mapped, "code")
                        commit('setValuePromotionProducts', { x: setIndex, i: index, result })
                    } else {
                        commit('setAlertShow', { value: true })
                        state.alertcontent = 'Please recheck your code'
                    }
                })
                .catch((error) => console.log(error))
        },
        async ck_promotion_code({ commit, state }, { value }) {
            await promotionService.getPromotionsbycode(value)
                .then((response) => {
                    if (response.length > 0) {
                        commit('setckPromotion', true)
                    } else {
                        commit('setckPromotion', false)
                    }
                })
        },
        ck_range({ commit, state }) {
            var promotion = state.value
            commit('setalertCondition', '')
            if (promotion.sets.length > 1) {
                var count_seleteConditions = 0
                var list_index_set = []
                _.forEach(promotion.sets, (set, x) => {
                    if (set.conditions.length > 0) {
                        // list_index_set.push(x)
                        count_seleteConditions++
                    }
                    list_index_set.push(x)
                })

                var list_length = list_index_set.length
                var alert_word = ''
                    // if(list_length > 1){
                        
                var checkDupPricetypeCus = false;
                if (count_seleteConditions > 1) {
                    // let key_old_value = promotion.sets.length - 2;
                    // let next_min = parseFloat(promotion.sets[key_old_value].conditions[0].max) + 1;

                    var check = 0;
                    var check_set_min = [];
                    var check_set_max = [];
                    var check_set_min_value = [];
                    var check_set_max_value = [];
                    _.forEach(list_index_set, (set, i) => {
                        _.forEach(list_index_set, (set2, k) => {
                            if (i < k) {
                                // console.log("set ==>", set);
                                // console.log("set2 ==>", set2);
                                /*
                      let h_min = promotion.sets[set].conditions[0].min
                      let h_max = promotion.sets[set].conditions[0].max
                      let t_min = promotion.sets[set2].conditions[0].min
                      let t_max = promotion.sets[set2].conditions[0].max
  
                      let old_max = promotion.sets[i].conditions[0].max;
                      let new_min = promotion.sets[k].conditions[0].min;
                      if(promotion.sets[i].conditions[0].type != "Count Item" && new_min <= old_max || parseFloat(new_min) > next_min) {
                        alert_word = 'Min value of "SET '+ (k + 1) + '" must be from range next of "SET ' + (i + 1) + '"';
                      } else if( (h_min != null && h_min != '') && (h_max != null && h_max != '') && (t_min != null && t_min != '') && (t_max != null && t_max != '')  ){
                        let is_intersec = ck_intersection(h_min,h_max,t_min,t_max)
                        if(is_intersec){
                          alert_word += 'SET '+(set+1)+', '+'SET '+(set2+1)+' Conditions Value Overlapped  <br/>'
                        }
                      }
                      */

                                _.forEach(promotion.sets[set].customers, (cus, c) => {
                                    var dupKey = promotion.sets[set2].customers.findIndex(item => item._id === cus._id)
                                    if (dupKey > -1) {
                                        if (promotion.sets[set].default_price == promotion.sets[set2].default_price) {
                                            let h_min = promotion.sets[set].conditions[0].min
                                            let h_max = promotion.sets[set].conditions[0].max
                                            let t_min = promotion.sets[set2].conditions[0].min
                                            let t_max = promotion.sets[set2].conditions[0].max

                                            let h_min_value = promotion.sets[set].conditions[0].min_value
                                            let h_max_value = promotion.sets[set].conditions[0].max_value
                                            let t_min_value = promotion.sets[set2].conditions[0].min_value
                                            let t_max_value = promotion.sets[set2].conditions[0].max_value

                                            let old_max = promotion.sets[set].conditions[0].max;
                                            let new_min = promotion.sets[set2].conditions[0].min;

                                            let old_max_value = promotion.sets[set].conditions[0].max_value;
                                            let new_min_value = promotion.sets[set2].conditions[0].min_value;

                                            // let next_min = parseFloat(promotion.sets[set].conditions[0].max) + 1;
                                            // let next_min = parseFloat(promotion.sets[check].conditions[0].max) + 1;

                                            // if (promotion.sets[set].conditions[0].type != "Count Item" && promotion.sets[set2].conditions[0].type != "Count Item" && parseFloat(new_min) <= parseFloat(old_max) || parseFloat(new_min) > parseFloat(next_min)) {
                                            if (promotion.sets[set].conditions[0].type != "Count Item" && promotion.sets[set2].conditions[0].type != "Count Item" && 
                                                promotion.sets[set].conditions[0].type != "Count Value" && promotion.sets[set2].conditions[0].type != "Count Value" &&
                                                promotion.sets[set].conditions[0].type != "Count Mix" && promotion.sets[set2].conditions[0].type != "Count Mix" &&
                                                parseFloat(new_min) <= parseFloat(old_max)) {
                                                alert_word += 'Min value of "SET ' + (set2 + 1) + '" must be from range next of "SET ' + (set + 1) + '" <br/>';
                                            } else if (((promotion.sets[set].conditions[0].type == "Count Item" && promotion.sets[set2].conditions[0].type == "Count Item") ||
                                                (promotion.sets[set].conditions[0].type == "Count Value" && promotion.sets[set2].conditions[0].type == "Count Value")) &&
                                                promotion.sets[set].conditions[0].count == promotion.sets[set2].conditions[0].count) {
                                                //เลือก Count Item และ min-max ไม่เป็นค่าว่าง
                                                if ((h_min != null && h_min != '') && (h_max != null && h_max != '') && (t_min != null && t_min != '') && (t_max != null && t_max != '')) {
                                                    let is_intersec = ck_intersection(h_min, h_max, t_min, t_max)
                                                    if (is_intersec) {
                                                        //มี min-max เท่ากับ set อื่น
                                                        alert_word += 'SET ' + (set + 1) + ', ' + 'SET ' + (set2 + 1) + ' Conditions Value Overlapped  <br/>'
                                                    }
                                                }
                                                //min-max เป็นค่าว่าง
                                                // if (h_min == null || h_min == '' || h_max == null || h_max == '' || t_min == null || t_min == '' || t_max == null || t_max == '') {
                                                //     alert_word += 'Value min or max can not null <br/>'
                                                // }
                                                if (h_min == null || h_min == '') {
                                                    if(check_set_min.indexOf(set + 1) == -1) {
                                                        alert_word += 'Value min SET ' + (set + 1) + ' can not null <br/>'
                                                        check_set_min.push(set + 1);
                                                    }
                                                }
                                                if (h_max == null || h_max == '') {
                                                    if(check_set_max.indexOf(set + 1) == -1) {
                                                        alert_word += 'Value max SET ' + (set + 1) + ' can not null <br/>'
                                                        check_set_max.push(set + 1);
                                                    }
                                                }
                                                if (t_min == null || t_min == '') {
                                                    if(check_set_min.indexOf(set2 + 1) == -1) {
                                                        alert_word += 'Value min SET ' + (set2 + 1) + ' can not null <br/>'
                                                        check_set_min.push(set2 + 1);
                                                    }
                                                }
                                                if (t_max == null || t_max == '') {
                                                    if(check_set_max.indexOf(set2 + 1) == -1) {
                                                        alert_word += 'Value max SET ' + (set2 + 1) + ' can not null <br/>'
                                                        check_set_max.push(set2 + 1);
                                                    }
                                                }
                                            } else if ((promotion.sets[set].conditions[0].type == "Count Mix" && promotion.sets[set2].conditions[0].type == "Count Mix") &&
                                                promotion.sets[set].conditions[0].count == promotion.sets[set2].conditions[0].count) {
                                                //เลือก Count Mix และ min-max ไม่เป็นค่าว่าง
                                                if ((h_min != null && h_min != '') && (h_max != null && h_max != '') && (t_min != null && t_min != '') && (t_max != null && t_max != '')) {
                                                    let is_intersec = ck_intersection(h_min, h_max, t_min, t_max)
                                                    if (is_intersec) {
                                                        //มี min-max เท่ากับ set อื่น
                                                        alert_word += 'SET ' + (set + 1) + ', ' + 'SET ' + (set2 + 1) + " Conditions QTY Overlapped <br/> because 'count item' have the same set of numbers. <br/>"
                                                    }
                                                }
                                                if ((h_min_value != null && h_min_value != '') && (h_max_value != null && h_max_value != '') && (t_min_value != null && t_min_value != '') && (t_max_value != null && t_max_value != '')) {
                                                    let is_intersec_value = ck_intersection(h_min_value, h_max_value, t_min_value, t_max_value)
                                                    if (is_intersec_value) {
                                                        //มี min-max เท่ากับ set อื่น
                                                        alert_word += 'SET ' + (set + 1) + ', ' + 'SET ' + (set2 + 1) + " Conditions Value Overlapped <br/> because 'count item' have the same set of numbers. <br/>"
                                                    }
                                                }
                                                if (h_min == null || h_min == '') {
                                                    if(check_set_min.indexOf(set + 1) == -1) {
                                                        alert_word += 'QTY min SET ' + (set + 1) + ' can not null <br/>'
                                                        check_set_min.push(set + 1);
                                                    }
                                                }
                                                if (h_min_value == null || h_min_value == '') {
                                                    if(check_set_min_value.indexOf(set + 1) == -1) {
                                                        alert_word += 'Value min SET ' + (set + 1) + ' can not null <br/>'
                                                        check_set_min_value.push(set + 1);
                                                    }
                                                }
                                                if (h_max == null || h_max == '') {
                                                    if(check_set_max.indexOf(set + 1) == -1) {
                                                        alert_word += 'QTY max SET ' + (set + 1) + ' can not null <br/>'
                                                        check_set_max.push(set + 1);
                                                    }
                                                }
                                                if (h_max_value == null || h_max_value == '') {
                                                    if(check_set_max.indexOf(set + 1) == -1) {
                                                        alert_word += 'Value max SET ' + (set + 1) + ' can not null <br/>'
                                                        check_set_max.push(set + 1);
                                                    }
                                                }
                                                if (t_min == null || t_min == '') {
                                                    if(check_set_min.indexOf(set2 + 1) == -1) {
                                                        alert_word += 'QTY min SET ' + (set2 + 1) + ' can not null <br/>'
                                                        check_set_min.push(set2 + 1);
                                                    }
                                                }
                                                if (t_min_value == null || t_min_value == '') {
                                                    if(check_set_min_value.indexOf(set2 + 1) == -1) {
                                                        alert_word += 'Value min SET ' + (set2 + 1) + ' can not null <br/>'
                                                        check_set_min_value.push(set2 + 1);
                                                    }
                                                }
                                                if (t_max == null || t_max == '') {
                                                    if(check_set_max.indexOf(set2 + 1) == -1) {
                                                        alert_word += 'QTY max SET ' + (set2 + 1) + ' can not null <br/>'
                                                        check_set_max.push(set2 + 1);
                                                    }
                                                }
                                                if (t_max_value == null || t_max_value == '') {
                                                    if(check_set_max_value.indexOf(set2 + 1) == -1) {
                                                        alert_word += 'Value max SET ' + (set2 + 1) + ' can not null <br/>'
                                                        check_set_max_value.push(set2 + 1);
                                                    }
                                                }
                                            }

                                            check = set2;
                                        } else {
                                            checkDupPricetypeCus = true;
                                        }
                                    } else {
                                        checkDupPricetypeCus = true;
                                    }
                                })
                            }
                        })
                    })
                }
                if (alert_word == '') {
                    // let 
                    if (promotion.sets.length > 1) {
                        // if(promotion.sets.length == list_length){
                        if (promotion.sets.length == count_seleteConditions && checkDupPricetypeCus == false) {
                            let count_qty = 0
                            let count_value = 0
                            _.forEach(promotion.sets, (set, x) => {
                                if (set.conditions[0].type == "QTY") {
                                    count_qty++
                                } else {
                                    count_value++
                                }
                            })
                            if (count_qty != list_length && count_value != list_length) {
                                alert_word = 'SET Conditions Type Differ'
                            }
                        } else {
                            // alert_word = 'SET Conditions Type Differ'
                        }

                    }
                }
                // console.log('alert_word : ' + alert_word)
                commit('setalertCondition', alert_word)

            }

        },
        update({ commit, state }, { field, value }) {
            commit('update', { field, value })
        },
        // checkDupPromoCode({commit,state}, promo_code){
        //   promotionService.getPromotionsbycode(promo_code)
        //       .then((response) => {
        //         if(response.length > 0){
        //           commit('setckPromotion',true)
        //         }else{
        //           commit('setckPromotion',false)
        //         }
        //     })
        //   }
    },
    getters: {
        step: state => {
            return state.step
        },
        groups: state => {
            return state.groups
        },
        subgroups: state => {
            return state.subgroups
        },
        cggroups: state => {
            return state.cggroups
        },
        unitmaster: state => {
            return state.unitmaster
        },
        sets: state => {
            return state.value.sets
        },
        probrowse: state => {
            return state.probrowse
        },
        stepper: state => {
            return state.stepper
        },
        value: state => {
            return state.value
        },
        customer_groups: state => {
            return state.customer_groups
        },
        product_groups: state => {
            return state.product_groups
        },
        origin_customer_groups: state => {
            return state.origin_customer_groups
        },
        default_price: state => {
            return state.default_price
        },
        product_group_length: state => {
            const v = _.uniqBy(state.value.products, 'productcg_code')
            return v.length
        },
        alertshow: state => {
            return state.alertshow
        },
        alertcontent: state => {
            return state.alertcontent
        },
        alertCondition: state => {
            return state.alertCondition
        },
        statusAction: state => {
            return state.statusAction
        },
        loadData: state => {
            return state.loadData
        }
    }
}
/* eslint-disable */